export default __webpack_public_path__ + "45c896444b4ac3153c5b8834df0297e0.png";